import React, { useEffect } from 'react';
import Image from 'next/image';

import { usePublicRuntimeConfig } from '../../hooks/usePublicRuntimeConfig';

import {
  Modal,
  Iframe,
  CloseIconPositioner,
  IframeWrapper,
  IframePositioner
} from './styles';

import closeIcon from '@/images/x-icon.svg';
import { useEscapeEvent } from '../../hooks/useEscapeEvent';

interface Props {
  title: string;
  vimeoId: string;
  showingVideo: boolean;
  setShowingVideo: (showing: boolean) => void;
}

export function Lightbox({
  title,
  showingVideo,
  setShowingVideo,
  vimeoId
}: Props) {
  const { vimeoToken } = usePublicRuntimeConfig();

  const videoNodeId = `video-${vimeoId}`;

  useEscapeEvent(() => setShowingVideo(false));

  useEffect(() => {
    if (showingVideo) {
      initVimeoAnalytics();
    }
  }, [showingVideo]);

  const initVimeoAnalytics = async () => {
    if ((window as any).Vimeo && showingVideo) {
      const iframe = document.querySelector(`#${videoNodeId}`);
      const player = new (window as any).Vimeo.Player(iframe);
      const { VimeoAnalytics } = await import(
        '@segment/analytics.js-video-plugins/dist/index.umd.js'
      );
      const vimeoAnalytics = new VimeoAnalytics(player, vimeoToken);
      vimeoAnalytics.initialize();
    }
  };

  return (
    <>
      {showingVideo && (
        <Modal
          aria-modal="true"
          aria-label="Vimeo Video Modal"
          aria-labelledby={title}
        >
          <CloseIconPositioner onClick={() => setShowingVideo(false)}>
            <Image src={closeIcon} alt="close video" />
          </CloseIconPositioner>
          <IframePositioner>
            <IframeWrapper>
              <Iframe
                id={videoNodeId}
                src={`https://player.vimeo.com/video/${vimeoId}?autoplay=1`}
                frameBorder="0"
                allowFullScreen={true}
                title={title}
                className="iframe"
              />
            </IframeWrapper>
          </IframePositioner>
        </Modal>
      )}
    </>
  );
}
